import {createReducer, on} from '@ngrx/store';
import {LineChartDataModel} from '../../../../models/line-chart-data.model';
import {HeightChartTableData} from '../models/fetch-height-chart-table-data.model';
import {WeightChartTableData} from '../models/fetch-weight-chart-table-data.model';
import {
  ClearState,
  FetchBmiChartDataFailure,
  FetchBmiChartDataRequest,
  FetchBmiChartDataSuccess,
  FetchBmiChartTableDataFailure,
  FetchBmiChartTableDataRequest,
  FetchBmiChartTableDataSuccess,
  FetchBmiGoalFilterDataFailure,
  FetchBmiGoalFilterDataRequest,
  FetchBmiGoalFilterDataSuccess,
  FetchAdultBmiGoalFilterDataFailure,
  FetchAdultBmiGoalFilterDataRequest,
  FetchAdultBmiGoalFilterDataSuccess,
  FetchDailyFoodChartDataFailure,
  FetchDailyFoodChartDataRequest,
  FetchDailyFoodChartDataSuccess,
  FetchDailyPAChartDataFailure,
  FetchDailyPAChartDataRequest,
  FetchDailyPAChartDataSuccess,
  FetchDailySTChartDataFailure,
  FetchDailySTChartDataRequest,
  FetchDailySTChartDataSuccess,
  FetchHeightChartDataFailure,
  FetchHeightChartDataRequest,
  FetchHeightChartDataSuccess,
  FetchHeightChartTableDataFailure,
  FetchHeightChartTableDataRequest,
  FetchHeightChartTableDataSuccess, FetchJournalChartDataFailure, FetchJournalChartDataRequest, FetchJournalChartDataSuccess, FetchJournalChartTableDataFailure, FetchJournalChartTableDataRequest, FetchJournalChartTableDataSuccess, FetchPATableDataFailure,
  FetchPATableDataRequest,
  FetchPATableDataSuccess,
  FetchSTTableDataFailure,
  FetchSTTableDataRequest,
  FetchSTTableDataSuccess,
  FetchWeeklyFoodChartDataFailure,
  FetchWeeklyFoodChartDataRequest,
  FetchWeeklyFoodChartDataSuccess,
  FetchWeeklyFoodChartTableDataFailure,
  FetchWeeklyFoodChartTableDataRequest,
  FetchWeeklyFoodChartTableDataSuccess,
  FetchWeeklyPAChartDataFailure,
  FetchWeeklyPAChartDataRequest,
  FetchWeeklyPAChartDataSuccess,
  FetchWeeklySTChartDataFailure,
  FetchWeeklySTChartDataRequest,
  FetchWeeklySTChartDataSuccess,
  FetchWeightChartDataFailure,
  FetchWeightChartDataRequest,
  FetchWeightChartDataSuccess,
  FetchWeightChartTableDataFailure,
  FetchWeightChartTableDataRequest,
  FetchWeightChartTableDataSuccess
} from './progress.actions';
import {GroupedBarChartModel} from '../../../../models/grouped-bar-chart.model';
import {BarChartModel} from '../../../../models/bar-chart.model';
import {WeeklyFoodChartTableData} from '../models/fetch-weekly-food-chart-table-data.model';
import {BmiChartTableData} from '../models/fetch-bmi-chart-table-data.model';
import {Filter} from '../../../../models/filter';
import {JournalChartDataModel} from '../models/fetch-journal-chart-data.model';
import {JournalChartTableData} from '../models/fetch-journal-chart-table-data.model';

// State for this feature (Progress)
export interface ProgressState {
  height: {
    chartData: {
      loading: boolean,
      data: LineChartDataModel,
      forPrint?: boolean,
    },
    tableData: {
      loading: boolean,
      data: HeightChartTableData,
      forPrint?: boolean,
    }
  },
  weight: {
    chartData: {
      loading: boolean,
      data: LineChartDataModel,
      forPrint?: boolean,
    },
    tableData: {
      loading: boolean,
      data: WeightChartTableData,
      forPrint?: boolean,
    }
  },
  dailyFood: {
    chartData: {
      loading: boolean,
      data: GroupedBarChartModel,
      forPrint?: boolean,
    },
  },
  weeklyFood: {
    chartData: {
      loading: boolean,
      data: BarChartModel,
      forPrint?: boolean,
    },
    tableData: {
      loading: boolean,
      data: WeeklyFoodChartTableData,
      forPrint?: boolean,
    }
  },
  bmi: {
    chartData: {
      loading: boolean,
      data: LineChartDataModel,
      forPrint?: boolean,
    },
    tableData: {
      loading: boolean,
      data: BmiChartTableData,
      forPrint?: boolean,
    }
  },
  bmiGoalFilter: Filter,
  adultBmiGoalFilter: Filter,
  dailyPA: {
    chartData: {
      loading: boolean,
      data: GroupedBarChartModel,
      forPrint?: boolean,
    },
  },
  weeklyPA: {
    chartData: {
      loading: boolean,
      data: BarChartModel,
      forPrint?: boolean,
    },
    tableData: {
      loading: boolean,
      data: WeeklyFoodChartTableData,
      forPrint?: boolean,
    }
  },
  journal: {
    chartData: {
      loading: boolean,
      data: JournalChartDataModel,
      forPrint?: boolean,
    },
    tableData: {
      loading: boolean,
      data: JournalChartTableData,
      forPrint?: boolean,
    }
  },
  dailyST: {
    chartData: {
      loading: boolean,
      data: GroupedBarChartModel,
      forPrint?: boolean,
    },
  },
  weeklyST: {
    chartData: {
      loading: boolean,
      data: BarChartModel,
      forPrint?: boolean,
    },
    tableData: {
      loading: boolean,
      data: WeeklyFoodChartTableData,
      forPrint?: boolean,
    }
  },
}

const initialState: ProgressState = {
  height: {
    chartData: {
      loading: false,
      data: null,
    },
    tableData: {
      loading: false,
      data: null,
    },
  },
  weight: {
    chartData: {
      loading: false,
      data: null,
    },
    tableData: {
      loading: false,
      data: null,
    },
  },
  dailyFood: {
    chartData: {
      loading: false,
      data: null,
    },
  },
  weeklyFood: {
    chartData: {
      loading: false,
      data: null,
    },
    tableData: {
      loading: false,
      data: null,
    },
  },
  bmi: {
    chartData: {
      loading: false,
      data: null,
    },
    tableData: {
      loading: false,
      data: null,
    },
  },
  bmiGoalFilter: {
    list: [],
    total: null,
    pageNumber: 1,
    limit: 10,
    hasNext: false,
    hasPrev: false,
    loading: false
  },
  adultBmiGoalFilter: {
    list: [],
    total: null,
    pageNumber: 1,
    limit: 10,
    hasNext: false,
    hasPrev: false,
    loading: false
  },
  dailyPA: {
    chartData: {
      loading: false,
      data: null,
    },
  },
  weeklyPA: {
    chartData: {
      loading: false,
      data: null,
    },
    tableData: {
      loading: false,
      data: null,
    },
  },
  dailyST: {
    chartData: {
      loading: false,
      data: null,
    },
  },
  weeklyST: {
    chartData: {
      loading: false,
      data: null,
    },
    tableData: {
      loading: false,
      data: null,
    },
  },
  journal: {
    chartData: {
      loading: false,
      data: null,
    },
    tableData: {
      loading: false,
      data: null,
    },
  },
};

export const reducer = createReducer(
  initialState,

  // CLEAR STATE
  on(ClearState, () => initialState),

  // Fetch Height Chart Data
  on(FetchHeightChartDataRequest, (state, props) => ({
    ...state,
    height: {
      ...state.height,
      chartData: {
        ...initialState.height.chartData,
        loading: true,
        forPrint: props.forPrint,
      }
    },
  })),
  on(FetchHeightChartDataSuccess, (state, props) => ({
    ...state,
    height: {
      ...state.height,
      chartData: {
        data: props.data,
        loading: false,
        forPrint: state.height.chartData.forPrint,
      }
    },
  })),
  on(FetchHeightChartDataFailure, (state) => ({
    ...state,
    height: {
      ...state.height,
      chartData: {
        ...state.height.chartData,
        loading: false,
        forPrint: state.height.chartData.forPrint,
      }
    },
  })),

  // Fetch Height Chart Table Data
  on(FetchHeightChartTableDataRequest, (state, props) => ({
    ...state,
    height: {
      ...state.height,
      tableData: {
        data: {
          ...state.height.tableData.data,
          list: props.payload?.pageNumber === 1 ? [] : state.height.tableData.data?.list,
        },
        loading: true,
        forPrint: props.forPrint,
      }
    },
  })),
  on(FetchHeightChartTableDataSuccess, (state, props) => ({
    ...state,
    height: {
      ...state.height,
      tableData: {
        data: {
          ...props.data,
          list: [...state.height.tableData.data?.list, ...props.data?.list],
        },
        loading: false,
        forPrint: state.height.tableData.forPrint,
      }
    },
  })),
  on(FetchHeightChartTableDataFailure, (state) => ({
    ...state,
    height: {
      ...state.height,
      tableData: {
        ...state.height.tableData,
        loading: false,
        forPrint: state.height.tableData.forPrint,
      }
    },
  })),

  // Fetch Weight Chart Data
  on(FetchWeightChartDataRequest, (state, props) => ({
    ...state,
    weight: {
      ...state.weight,
      chartData: {
        ...initialState.weight.chartData,
        loading: true,
        forPrint: props.forPrint,
      }
    },
  })),
  on(FetchWeightChartDataSuccess, (state, props) => ({
    ...state,
    weight: {
      ...state.weight,
      chartData: {
        data: props.data,
        loading: false,
        forPrint: state.weight.chartData.forPrint,
      }
    },
  })),
  on(FetchWeightChartDataFailure, (state) => ({
    ...state,
    weight: {
      ...state.weight,
      chartData: {
        ...state.weight.chartData,
        loading: false,
        forPrint: state.weight.chartData.forPrint,
      }
    },
  })),

  // Fetch Weight Chart Table Data
  on(FetchWeightChartTableDataRequest, (state, props) => ({
    ...state,
    weight: {
      ...state.weight,
      tableData: {
        data: {
          ...state.weight.tableData.data,
          list: props.payload?.pageNumber === 1 ? [] : state.weight.tableData.data?.list,
        },
        loading: true,
        forPrint: props.forPrint,
      }
    },
  })),
  on(FetchWeightChartTableDataSuccess, (state, props) => ({
    ...state,
    weight: {
      ...state.weight,
      tableData: {
        data: {
          ...props.data,
          list: [...state.weight.tableData.data?.list, ...props.data?.list],
        },
        loading: false,
        forPrint: state.weight.tableData.forPrint,
      }
    },
  })),
  on(FetchWeightChartTableDataFailure, (state) => ({
    ...state,
    weight: {
      ...state.weight,
      tableData: {
        ...state.weight.tableData,
        loading: false,
        forPrint: state.weight.tableData.forPrint,
      }
    },
  })),

  // Fetch Daily Food Chart Data
  on(FetchDailyFoodChartDataRequest, (state, props) => ({
    ...state,
    dailyFood: {
      ...state.dailyFood,
      chartData: {
        ...initialState.dailyFood.chartData,
        loading: true,
        forPrint: props.forPrint,
      }
    },
  })),
  on(FetchDailyFoodChartDataSuccess, (state, props) => ({
    ...state,
    dailyFood: {
      ...state.dailyFood,
      chartData: {
        data: props.data,
        loading: false,
        forPrint: state.dailyFood.chartData.forPrint,
      }
    },
  })),
  on(FetchDailyFoodChartDataFailure, (state) => ({
    ...state,
    dailyFood: {
      ...state.dailyFood,
      chartData: {
        ...state.dailyFood.chartData,
        loading: false,
        forPrint: state.dailyFood.chartData.forPrint,
      }
    },
  })),

  // Fetch Weekly Food Chart Data
  on(FetchWeeklyFoodChartDataRequest, (state, props) => ({
    ...state,
    weeklyFood: {
      ...state.weeklyFood,
      chartData: {
        ...initialState.weeklyFood.chartData,
        loading: true,
        forPrint: props.forPrint,
      }
    },
  })),
  on(FetchWeeklyFoodChartDataSuccess, (state, props) => ({
    ...state,
    weeklyFood: {
      ...state.weeklyFood,
      chartData: {
        data: props.data,
        loading: false,
        forPrint: state.weeklyFood.chartData.forPrint,
      }
    },
  })),
  on(FetchWeeklyFoodChartDataFailure, (state) => ({
    ...state,
    weeklyFood: {
      ...state.weeklyFood,
      chartData: {
        ...state.weeklyFood.chartData,
        loading: false,
        forPrint: state.weeklyFood.chartData.forPrint,
      }
    },
  })),

  // Fetch Weekly Food Chart Table Data
  on(FetchWeeklyFoodChartTableDataRequest, (state, props) => ({
    ...state,
    weeklyFood: {
      ...state.weeklyFood,
      tableData: {
        data: {
          ...state.weeklyFood.tableData.data,
          list: props.payload?.pageNumber === 1 ? [] : state.weeklyFood.tableData.data?.list,
        },
        loading: true,
        forPrint: props.forPrint,
      }
    },
  })),
  on(FetchWeeklyFoodChartTableDataSuccess, (state, props) => ({
    ...state,
    weeklyFood: {
      ...state.weeklyFood,
      tableData: {
        data: {
          ...props.data,
          list: [...state.weeklyFood.tableData.data?.list, ...props.data?.list],
        },
        loading: false,
        forPrint: state.weeklyFood.tableData.forPrint,
      }
    },
  })),
  on(FetchWeeklyFoodChartTableDataFailure, (state) => ({
    ...state,
    weeklyFood: {
      ...state.weeklyFood,
      tableData: {
        ...state.weeklyFood.tableData,
        loading: false,
        forPrint: state.weeklyFood.tableData.forPrint,
      }
    },
  })),

  // Fetch Bmi Chart Data
  on(FetchBmiChartDataRequest, (state, props) => ({
    ...state,
    bmi: {
      ...state.bmi,
      chartData: {
        ...initialState.bmi.chartData,
        loading: true,
        forPrint: props.forPrint,
      }
    },
  })),
  on(FetchBmiChartDataSuccess, (state, props) => ({
    ...state,
    bmi: {
      ...state.bmi,
      chartData: {
        data: props.data,
        loading: false,
        forPrint: state.bmi.chartData.forPrint,
      }
    },
  })),
  on(FetchBmiChartDataFailure, (state) => ({
    ...state,
    bmi: {
      ...state.bmi,
      chartData: {
        ...state.bmi.chartData,
        loading: false,
        forPrint: state.bmi.chartData.forPrint,
      }
    },
  })),

  // Fetch Bmi Chart Table Data
  on(FetchBmiChartTableDataRequest, (state, props) => ({
    ...state,
    bmi: {
      ...state.bmi,
      tableData: {
        data: {
          ...state.bmi.tableData.data,
          list: props.payload?.pageNumber === 1 ? [] : state.bmi.tableData.data?.list,
        },
        loading: true,
        forPrint: props.forPrint,
      }
    },
  })),
  on(FetchBmiChartTableDataSuccess, (state, props) => ({
    ...state,
    bmi: {
      ...state.bmi,
      tableData: {
        data: {
          ...props.data,
          list: [...state.bmi.tableData.data?.list, ...props.data?.list],
        },
        loading: false,
        forPrint: state.bmi.tableData.forPrint,
      }
    },
  })),
  on(FetchBmiChartTableDataFailure, (state) => ({
    ...state,
    bmi: {
      ...state.bmi,
      tableData: {
        ...state.bmi.tableData,
        loading: false,
        forPrint: state.bmi.tableData.forPrint,
      }
    },
  })),

  // Fetch Bmi Goal Filter
  on(FetchBmiGoalFilterDataRequest, (state, props) => ({
    ...state,
    bmiGoalFilter: {
      ...state.bmiGoalFilter,
      loading: true
    }
  })),
  on(FetchBmiGoalFilterDataSuccess, (state, props) => ({
    ...state,
    bmiGoalFilter: {
      ...props.data,
      loading: false
    }
  })),
  on(FetchBmiGoalFilterDataFailure, (state) => ({
    ...state,
    bmiGoalFilter: {
      ...state.bmiGoalFilter,
      loading: false
    }
  })),

  // Fetch Adult Bmi Goal Filter
  on(FetchAdultBmiGoalFilterDataRequest, (state, props) => ({
    ...state,
    adultBmiGoalFilter: {
      ...state.adultBmiGoalFilter,
      loading: true
    }
  })),
  on(FetchAdultBmiGoalFilterDataSuccess, (state, props) => ({
    ...state,
    adultBmiGoalFilter: {
      ...props.data,
      loading: false
    }
  })),
  on(FetchAdultBmiGoalFilterDataFailure, (state) => ({
    ...state,
    adultBmiGoalFilter: {
      ...state.adultBmiGoalFilter,
      loading: false
    }
  })),

  // Fetch Daily PA Data
  on(FetchDailyPAChartDataRequest, (state, props) => ({
    ...state,
    dailyPA: {
      ...state.dailyPA,
      chartData: {
        ...initialState.dailyPA.chartData,
        loading: true,
        forPrint: props.forPrint,
      }
    },
  })),
  on(FetchDailyPAChartDataSuccess, (state, props) => ({
    ...state,
    dailyPA: {
      ...state.dailyPA,
      chartData: {
        data: props.data,
        loading: false,
        forPrint: state.dailyPA.chartData.forPrint,
      }
    },
  })),
  on(FetchDailyPAChartDataFailure, (state) => ({
    ...state,
    dailyPA: {
      ...state.dailyPA,
      chartData: {
        ...state.dailyPA.chartData,
        loading: false,
        forPrint: state.dailyPA.chartData.forPrint,
      }
    },
  })),

  // Fetch Weekly PA Data
  on(FetchWeeklyPAChartDataRequest, (state, props) => ({
    ...state,
    weeklyPA: {
      ...state.weeklyPA,
      chartData: {
        ...initialState.weeklyPA.chartData,
        loading: true,
        forPrint: props.forPrint,
      }
    },
  })),
  on(FetchWeeklyPAChartDataSuccess, (state, props) => ({
    ...state,
    weeklyPA: {
      ...state.weeklyPA,
      chartData: {
        data: props.data,
        loading: false,
        forPrint: state.weeklyPA.chartData.forPrint,
      }
    },
  })),
  on(FetchWeeklyPAChartDataFailure, (state) => ({
    ...state,
    weeklyPA: {
      ...state.weeklyPA,
      chartData: {
        ...state.weeklyPA.chartData,
        loading: false,
        forPrint: state.weeklyPA.chartData.forPrint,
      }
    },
  })),

  // Fetch Weekly PA Table Data
  on(FetchPATableDataRequest, (state, props) => ({
    ...state,
    weeklyPA: {
      ...state.weeklyPA,
      tableData: {
        data: {
          ...state.weeklyPA.tableData.data,
          list: props.payload?.pageNumber === 1 ? [] : state.weeklyPA.tableData.data?.list,
        },
        loading: true,
        forPrint: props.forPrint,
      }
    },
  })),
  on(FetchPATableDataSuccess, (state, props) => ({
    ...state,
    weeklyPA: {
      ...state.weeklyPA,
      tableData: {
        data: {
          ...props.data,
          list: [...state.weeklyPA.tableData.data?.list, ...props.data?.list],
        },
        loading: false,
        forPrint: state.weeklyPA.tableData.forPrint,
      }
    },
  })),
  on(FetchPATableDataFailure, (state) => ({
    ...state,
    weeklyPA: {
      ...state.weeklyPA,
      tableData: {
        ...state.weeklyPA.tableData,
        loading: false,
        forPrint: state.weeklyPA.tableData.forPrint,
      }
    },
  })),



  // Fetch Daily ST Chart Data
  on(FetchDailySTChartDataRequest, (state, props) => ({
    ...state,
    dailyST: {
      ...state.dailyST,
      chartData: {
        ...initialState.dailyST.chartData,
        loading: true,
        forPrint: props.forPrint,
      }
    },
  })),
  on(FetchDailySTChartDataSuccess, (state, props) => ({
    ...state,
    dailyST: {
      ...state.dailyST,
      chartData: {
        data: props.data,
        loading: false,
        forPrint: state.dailyST.chartData.forPrint,
      }
    },
  })),
  on(FetchDailySTChartDataFailure, (state) => ({
    ...state,
    dailyST: {
      ...state.dailyST,
      chartData: {
        ...state.dailyST.chartData,
        loading: false,
        forPrint: state.dailyST.chartData.forPrint,
      }
    },
  })),

  // Fetch Weekly ST Data
  on(FetchWeeklySTChartDataRequest, (state, props) => ({
    ...state,
    weeklyST: {
      ...state.weeklyST,
      chartData: {
        ...initialState.weeklyST.chartData,
        loading: true,
        forPrint: props.forPrint,
      }
    },
  })),
  on(FetchWeeklySTChartDataSuccess, (state, props) => ({
    ...state,
    weeklyST: {
      ...state.weeklyST,
      chartData: {
        data: props.data,
        loading: false,
        forPrint: state.weeklyST.chartData.forPrint,
      }
    },
  })),
  on(FetchWeeklySTChartDataFailure, (state) => ({
    ...state,
    weeklyST: {
      ...state.weeklyST,
      chartData: {
        ...state.weeklyST.chartData,
        loading: false,
        forPrint: state.weeklyST.chartData.forPrint,
      }
    },
  })),

  // Fetch Weekly ST Table Data
  on(FetchSTTableDataRequest, (state, props) => ({
    ...state,
    weeklyST: {
      ...state.weeklyST,
      tableData: {
        data: {
          ...state.weeklyST.tableData.data,
          list: props.payload?.pageNumber === 1 ? [] : state.weeklyST.tableData.data?.list,
        },
        loading: true,
        forPrint: props.forPrint,
      }
    },
  })),
  on(FetchSTTableDataSuccess, (state, props) => ({
    ...state,
    weeklyST: {
      ...state.weeklyST,
      tableData: {
        data: {
          ...props.data,
          list: [...state.weeklyST.tableData.data?.list, ...props.data?.list],
        },
        loading: false,
        forPrint: state.weeklyST.tableData.forPrint,
      }
    },
  })),
  on(FetchSTTableDataFailure, (state) => ({
    ...state,
    weeklyST: {
      ...state.weeklyST,
      tableData: {
        ...state.weeklyST.tableData,
        loading: false,
        forPrint: state.weeklyST.tableData.forPrint,
      }
    },
  })),

  // Fetch Journal Chart Data
  on(FetchJournalChartDataRequest, (state, props) => ({
    ...state,
    journal: {
      ...state.journal,
      chartData: {
        ...initialState.journal.chartData,
        loading: true,
        forPrint: props.forPrint,
      }
    },
  })),
  on(FetchJournalChartDataSuccess, (state, props) => ({
    ...state,
    journal: {
      ...state.journal,
      chartData: {
        data: props.data,
        loading: false,
        forPrint: state.journal.chartData.forPrint,
      }
    },
  })),
  on(FetchJournalChartDataFailure, (state) => ({
    ...state,
    journal: {
      ...state.journal,
      chartData: {
        ...state.journal.chartData,
        loading: false,
        forPrint: state.journal.chartData.forPrint,
      }
    },
  })),

  // Fetch Journal Chart Table Data
  on(FetchJournalChartTableDataRequest, (state, props) => ({
    ...state,
    journal: {
      ...state.journal,
      tableData: {
        data: {
          ...state.journal.tableData.data,
          list: props.payload?.pageNumber === 1 ? [] : state.journal.tableData.data?.list,
        },
        loading: true,
        forPrint: props.forPrint,
      }
    },
  })),
  on(FetchJournalChartTableDataSuccess, (state, props) => ({
    ...state,
    journal: {
      ...state.journal,
      tableData: {
        data: {
          ...props.data,
          list: [...state.journal.tableData.data?.list, ...props.data?.list],
        },
        loading: false,
        forPrint: state.journal.tableData.forPrint,
      }
    },
  })),
  on(FetchJournalChartTableDataFailure, (state) => ({
    ...state,
    journal: {
      ...state.journal,
      tableData: {
        ...state.journal.tableData,
        loading: false,
        forPrint: state.journal.tableData.forPrint,
      }
    },
  })),

);
